<template>
  <div
    class="spotify-authorization"
    :class="{'relative' : isBusy}"
  >
    <mj-spinner
      v-if="isBusy"
      :size="200"
      :class="{'absolute w-full h-full flex-col items-center bg-white-transparent' : isBusy}"
    >
      <div class="text-2xl font-semibold">
        Authorisierung läuft...
      </div>
    </mj-spinner>
    <mj-configuratin-wizard-header>
      <template #headline>
        Do it again!
      </template>
      <template #info-text>
        Seit deinem letzten Besuch ist leider deine Spotify Autorisierung erloschen.
        Bitte autorisiere Spotify erneut um die volle Power von Jukie zu nutzen.
      </template>
    </mj-configuratin-wizard-header>
    <mj-configuratin-wizard-content class="flex flex-col md:flex-row">
      <div class="configuration-wizard-cta mb-16 w-full text-center md:mb-0 md:w-1/2 md:text-left">
        <h2 class="mb-12 font-semibold text-2xl">
          Verknüpfe die Moment-Juke mit Spotify
        </h2>
        <a :href="authorizeSpotify">
          <mj-button
            class="btn-primary"
          >
            Spotify autorisieren
          </mj-button>
        </a>
      </div>
      <div class="configuration-wizard-illustration w-full md:w-1/2">
        <mj-icon
          src="authentication"
          class="w-full h-auto"
          proportions="rectangle"
        />
      </div>
    </mj-configuratin-wizard-content>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getSpotifyAuthorizationURI } from '@/helpers/index';
import ConfigurationWizardHeader from '@/components/configuration-wizard/ConfigurationWizardHeader.vue';
import ConfigurationWizardContent from '@/components/configuration-wizard/ConfigurationWizardContent.vue';

export default {
  name: 'SpotifyAuthorization',

  components: {
    'mj-configuratin-wizard-header': ConfigurationWizardHeader,
    'mj-configuratin-wizard-content': ConfigurationWizardContent,
  },

  data() {
    return {
      isBusy: false,
    };
  },

  computed: {
    ...mapGetters(['isSpotifyAuthorized']),
    authorizeSpotify() {
      return getSpotifyAuthorizationURI();
    },
  },

  methods: {
    ...mapActions(['authorizeSpotifyUser', 'updateSpotifyAuthorizationStatus']),
  },

  created() {
    if (this.isSpotifyAuthorized) {
      this.$router.push({ name: 'event.track.search' });
    }

    const { code } = this.$route.query;
    if (code) {
      this.isBusy = true;
      this.authorizeSpotifyUser({ code, redirectUri: process.env.VUE_APP_SPOTIFY_AUTHORITATION_REDIRECT })
        .then(() => {
          this.updateSpotifyAuthorizationStatus(true)
            .then(() => {
              this.$router.push({ name: 'event.track.search' });
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.isBusy = false;
            });
        })
        .catch(error => {
          console.log(error);
        });
    }
  },


};

</script>

<style lang="scss" scoped>

.configuration-wizard {

  &-illustration {
    max-width: 35rem;
  }
}

  .bg-white-transparent {
    background-color: rgba(255, 255, 255, .9);
  }
</style>
